import { MILLISECONDS_PER_MINUTE } from '@/constants/date-time';

export default {
  /**
   * Returns the numeric value of the given timestamp as the number of milliseconds
   * since January 1, 1970, 00:00:00 UTC adjusted to match the given UTC offset. (may be negative)
   *
   * @param offset | Integer - target offset of returned time in minutes
   * @param date | Date - starting Date
   * @returns {Number}
   */
  getDestinationTime(offset, date) {
    const dateUTC = date.getTime() + (date.getTimezoneOffset() * MILLISECONDS_PER_MINUTE);
    return dateUTC + (offset * MILLISECONDS_PER_MINUTE);
  },
}